import React from 'react'
import cx from 'classnames'
import Styles from './ReadOnlyAttribute.module.scss'
import { InformationCircleContained } from 'blaze-ui/icons'
import { Heading } from 'blaze-ui/Heading/Heading'
import { Tooltip } from 'components/Tooltip/Tooltip'
import { useIsSystemRedesign } from 'hooks/useIsSystemRedesign'

type ReadOnlyAttributeProps = {
  title: string
  description: string
  children: React.ReactNode
  hideTooltip?: boolean
  action?: React.ReactNode
}

export const ReadOnlyAttribute = ({
  title,
  description,
  children,
  hideTooltip = false,
  action,
}: ReadOnlyAttributeProps) => {
  const isSystemRedesignEnabled = useIsSystemRedesign()
  const headingLevel = isSystemRedesignEnabled ? 4 : 5
  const tooltipColor = isSystemRedesignEnabled ? 'var(--dark-15)' : 'var(--dark-40)'

  return (
    <div className={Styles.attribute}>
      <div className={cx(Styles.heading, { [Styles.withAction]: !!action })}>
        {action ? (
          <>
            <div className={Styles.titleSection}>
              <Heading level={headingLevel}>{title}</Heading>
              {!hideTooltip && (
                <Tooltip label={description} placement="top">
                  <span className={Styles.infoIconWrapper}>
                    <InformationCircleContained color={tooltipColor} size={16} />
                  </span>
                </Tooltip>
              )}
            </div>
            {action}
          </>
        ) : (
          <>
            <Heading level={headingLevel}>{title}</Heading>
            {!hideTooltip && (
              <Tooltip label={description} placement="top">
                <span className={Styles.infoIconWrapper}>
                  <InformationCircleContained color={tooltipColor} size={16} />
                </span>
              </Tooltip>
            )}
          </>
        )}
      </div>
      <div className={Styles.content}>{children}</div>
    </div>
  )
}
